// extracted by mini-css-extract-plugin
export default {"inputs":"FontSelector_inputs__JWD8F","displayer":"FontSelector_displayer__y3H3k","fade-in":"FontSelector_fade-in__kc4oy","fadeInAnimation":"FontSelector_fadeInAnimation__R1PJ9"};